import React from "react";
import { Link } from "react-router-dom";

import { BugOff } from "lucide-react";
import { Glitch } from "../../test/Glitch/Glitch";
import style from "./Logo.module.scss";

const Logo = () => {
  return (
    <Link className={style.logo} to="/">
      <BugOff
        strokeWidth="0.7px"
        width="40px"
        height="40px"
        className={style.icon}
      />
      <div className={style.title}>0CHII</div>
    </Link>
  );
};

export default Logo;
